import { OrderPayload, OrderResponse, TrackedOrder } from '../types';
import api from './api';

export async function submitOrder(payload: OrderPayload): Promise<OrderResponse> {
  const { data } = await api.post<OrderResponse>('/orders', payload);
  return data;
}

export async function trackOrder(orderId: string, email: string): Promise<TrackedOrder> {
  const { data } = await api.get<TrackedOrder>(`/orders/${encodeURIComponent(orderId)}`, {
    params: { email },
  });
  return data;
}

// ── Shopping assistant ────────────────────────────────────────────────────────
export type AssistantMessage = { role: 'user' | 'assistant'; content: string };

export async function checkAssistantAvailable(): Promise<boolean> {
  try {
    const { data } = await api.get<{ available: boolean }>('/assistant/status');
    return !!data.available;
  } catch {
    return false;
  }
}

export async function askAssistant(messages: AssistantMessage[]): Promise<string> {
  const { data } = await api.post<{ reply: string }>('/assistant', { messages });
  return data.reply;
}
